// services/postService.ts
import axios from "axios";
import { MAIN_API_URL } from "../config/api";
import { Post, PostToBackend } from "../types/features/Post";
import { PaginatedResponse } from "../types/core/PaginatedResponse";

export const postService = {
  // 🔓 PUBLIC - Pas de token nécessaire
  async getAll(page: number = 1, perPage: number = 20): Promise<PaginatedResponse<Post>> {
    try {
      const response = await axios.get(`${MAIN_API_URL}/blog/posts`, {
        params: { page, per_page: perPage },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement des articles", error);
      throw error;
    }
  },

  // 🔓 PUBLIC - Pas de token nécessaire
  async getById(id: string): Promise<Post> {
    try {
      const response = await axios.get(`${MAIN_API_URL}/blog/posts/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement de l'article", error);
      throw error;
    }
  },

  // 🔓 PUBLIC - Pas de token nécessaire
  async getBySlug(slug: string): Promise<Post> {
    try {
      const response = await axios.get(`${MAIN_API_URL}/blog/posts/slug/${slug}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement de l'article par slug", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async create(token: string, data: PostToBackend): Promise<Post> {
    try {
      const response = await axios.post(`${MAIN_API_URL}/blog/posts`, {
        ...data,
        product_name: data.product_name || 'all',
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la création de l'article", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async update(token: string, id: string, data: Partial<PostToBackend>): Promise<Post> {
    try {
      const response = await axios.put(`${MAIN_API_URL}/blog/posts/${id}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la mise à jour de l'article", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async delete(token: string, id: string): Promise<void> {
    try {
      await axios.delete(`${MAIN_API_URL}/blog/posts/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.error("Erreur lors de la suppression de l'article", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async deleteMany(token: string, ids: string[]): Promise<void> {
    try {
      const promises = ids.map((id) => this.delete(token, id));
      await Promise.all(promises);
    } catch (error) {
      console.error("Erreur lors de la suppression multiple", error);
      throw error;
    }
  },
};